import { useMemo, Fragment } from 'react';
import _map from 'lodash/map';
import MLink from '@material-ui/core/Link';
import SelectField from './select-field';
import { licenses } from '../../utils/licenses';

const LicenseField = (props) => {
  const options = useMemo(() => _map(licenses, ({ label }, value) => ({ value, label })), []);

  return (
    <SelectField
      {...props}
      options={options}
      helperText={(
        <Fragment>
          Learn about
          {' '}
          <MLink href="https://creativecommons.org/licenses/" target="_blank">
            Creative Commons Licenses
          </MLink>
        </Fragment>
      )}
    />
  );
};

export default LicenseField;
